import React from 'react';
import { Badge } from '@dev-go4ellis/go4-design-system';
import './WhatFeeCovers.scss';

const ITEMS = [
  { label: 'Licensure verification', body: 'Every trainer credential-checked before they work.' },
  { label: 'Payment processing', body: 'Direct deposit to your trainers, no invoicing.' },
  { label: 'General liability insurance', body: 'Every shift is covered, no separate policy needed.' },
  { label: 'HIPAA-compliant documentation', body: 'Injury reports and treatment logs in your account.' },
  { label: 'EAP Generator', body: 'Create venue-specific Emergency Action Plans in minutes.' },
  { label: 'EMR Documentation', body: 'Electronic medical records for injury tracking and athlete health histories.' },
];

const WhatFeeCovers = () => (
  <section className="pl-fee-covers">
    <div className="pl-fee-covers__inner">
      <div className="pl-fee-covers__badge">
        <Badge variant="soft" color="info" size="sm">WHAT THE 17.5% COVERS</Badge>
      </div>

      <h2 className="pl-fee-covers__title">Everything below is included in the fee</h2>
      <p className="pl-fee-covers__subtitle">There are no add-on modules to buy.</p>

      <div className="pl-fee-covers__grid">
        {ITEMS.map((item) => (
          <div key={item.label} className="pl-fee-covers__item">
            <div className="pl-fee-covers__check">✓</div>
            <div>
              <div className="pl-fee-covers__label">{item.label}</div>
              <div className="pl-fee-covers__body">{item.body}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhatFeeCovers;
